<template>
	<div
		style="height: 100vh; overflow-y: auto"
		:style="{ 'background-color': this.$vuetify.theme.isDark ? '' : '#f5f6fa' }"
	>
		<v-container>
			<v-row justify="center" align="center" style="height: 80vh">
				<v-col cols="12" sm="9" md="6">
					<v-card flat color="transparent">
						<v-card-title>
							<v-row no-gutters justify="center" align="center">
								<v-col cols="12">
									<logo style="max-width: 95%;" />
								</v-col>
								<v-col cols="12" class="text-left">
									<div class="headline">Contáctanos</div>
									<div class="caption text--secondary">
										Envia tu pregunta a nuestro soporte tecnico
									</div>
								</v-col>
							</v-row>
						</v-card-title>
						<v-card-text>
							<v-row>
								<v-col cols="12" sm="4">
									<v-text-field
										solo
										flat
										data-cy="sender-text-field"
										v-model.trim="$v.form.sender.$model"
										label="Nombre"
										:error-messages="senderErrors"
										@input="$v.form.sender.$touch()"
										@blur="$v.form.sender.$touch()"
									>
									</v-text-field>
								</v-col>
								<v-col cols="12" sm="4">
									<v-text-field
										solo
										flat
										data-cy="cellphone-text-field"
										v-model.trim="$v.form.cellphone.$model"
										label="Telefono"
										:error-messages="cellphoneErrors"
										@input="$v.form.cellphone.$touch()"
										@blur="$v.form.cellphone.$touch()"
									/>
								</v-col>
								<v-col cols="12" sm="4">
									<v-select
										solo
										flat
										label="Tipo"
										:items="types"
										v-model="form.type"
									></v-select>
								</v-col>
								<v-col cols="12">
									<v-text-field
										solo
										flat
										data-cy="email-text-field"
										v-model.trim="$v.form.email.$model"
										label="Correo"
										:error-messages="emailErrors"
										@input="$v.form.email.$touch()"
										@blur="$v.form.email.$touch()"
									/>
								</v-col>
								<v-col cols="12">
									<v-textarea
										data-cy="description-text-field"
										v-model.trim="$v.form.description.$model"
										label="Descripcion"
										solo
										flat
										:error-messages="descriptionErrors"
										@input="$v.form.description.$touch()"
										@blur="$v.form.description.$touch()"
									/>
								</v-col>
							</v-row>
							<v-row>
								<v-col cols="12" sm="6">
									<v-btn block color="primary" @click="submit" :loading="loading">
										ENVIAR
									</v-btn>
								</v-col>
								<v-col cols="12" sm="6">
									<v-btn
										@click="hasHistory() ? $router.go(-1) : $router.push('/')"
										block
										color="accent"
									>
										regresar
									</v-btn>
								</v-col>
							</v-row>
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
		</v-container>
	</div>
</template>

<script>
import Logo from '@/assets/logo';
import { validationMixin } from 'vuelidate';
import { required, minLength, maxLength } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';

export default {
	name: 'Mailbox',
	components: {
		Logo,
	},
	mixins: [validationMixin],
	data() {
		return {
			loading: false,
			form: { type: '', description: '', cellphone: '', email: '', sender: '' },
			types: ['Consulta', 'Sugerencia', 'Reclamo'],
		};
	},
	validations: {
		form: {
			description: {
				required,
				minLength: minLength(3),
				maxLength: maxLength(100),
			},
			cellphone: {
				required,
				minLength: minLength(3),
				maxLength: maxLength(100),
			},
			email: {
				required,
				minLength: minLength(3),
				maxLength: maxLength(100),
			},
			sender: {
				required,
				minLength: minLength(3),
				maxLength: maxLength(100),
			},
		},
	},
	computed: {
		descriptionErrors() {
			const errors = [];
			if (!this.$v.form.description.$dirty) return errors;
			!this.$v.form.description.required && errors.push('Campo requerido');
			!this.$v.form.description.minLength && errors.push('Minimo 10 Caracteres');
			!this.$v.form.description.maxLength && errors.push('Maximo 1000 Caracteres');
			return errors;
		},
		cellphoneErrors() {
			const errors = [];
			if (!this.$v.form.cellphone.$dirty) return errors;
			!this.$v.form.cellphone.required && errors.push('Campo requerido');
			!this.$v.form.cellphone.minLength && errors.push('Minimo 8 Caracteres');
			!this.$v.form.cellphone.maxLength && errors.push('Maximo 8 Caracteres');
			return errors;
		},
		emailErrors() {
			const errors = [];
			if (!this.$v.form.email.$dirty) return errors;
			!this.$v.form.email.required && errors.push('Campo requerido');
			!this.$v.form.email.minLength && errors.push('Minimo 3 Caracteres');
			!this.$v.form.email.maxLength && errors.push('Maximo 100 Caracteres');
			return errors;
		},
		senderErrors() {
			const errors = [];
			if (!this.$v.form.sender.$dirty) return errors;
			!this.$v.form.sender.required && errors.push('Campo requerido');
			!this.$v.form.sender.minLength && errors.push('Minimo 3 Caracteres');
			!this.$v.form.sender.maxLength && errors.push('Maximo 100 Caracteres');
			return errors;
		},
	},
	methods: {
		async submit() {
			this.$v.$touch();
			if (!this.$v.$invalid) {
				this.loading = true;
				await this.save(this.form);
				this.clearInputs();
				this.$v.$reset();
				this.loading = false;
			}
		},
		hasHistory() {
			return window.history.length > 2;
		},
		clearInputs() {
			this.form = { type: '', description: '', cellphone: '', email: '', sender: '' };
		},
		...mapActions({
			save: 'Mailbox/save',
		}),
	},
};
</script>
